module.exports = __webpack_public_path__ + "static/img/sev-eye-severance.e718a1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/sev-eye-severance.jpg
// module id = ow9u
// module chunks = 0